// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { NotificationsQueries } from '../../../../types/server/modules/notifications/queries';

export type * from '../../../../types/server/modules/notifications/queries';

export const createQueries = ( requests: Requests ): NotificationsQueries => ({
  NotificationsCount: ( params?, headers? ) => {
        return requests.get( `/notifications-count`, params, headers );
      },
  NotificationsById: ( id, query, headers ) => { 
          return requests.get( `/notifications/${id}`, query, headers ); 
        },
  Notifications: ( params?, headers? ) => {
        return requests.get( `/notifications/:id?`, params, headers );
      }
});
